export default __webpack_public_path__ + "static/media/future-of-javascript.60b1bf63.md";